import { getLogger } from '@blueberry/observability'

type AlertType = 'error' | 'success' | 'info' | 'warning'

const logger = getLogger('alerts')

const alert = (type: AlertType, message: string) => {
  const template = document.getElementById(
    'alert-template',
  ) as HTMLTemplateElement | null
  if (template === null) {
    logger.error('Could not find alert template')
    return
  }

  const alert = template.content.cloneNode(true) as HTMLElement | null
  if (!alert) {
    logger.error('Could not clone alert template')
    return
  }

  const body = alert.querySelector('.alert')
  if (!body || !body.classList.contains('alert')) {
    logger.error('Could not find alert body')
    return
  }
  const contents = alert.querySelector('.alert-message') as HTMLElement | null
  if (!contents) {
    logger.error('Could not find alert message')
    return
  }

  body.classList.add(`alert-${type}`)
  body.setAttribute('data-alert-type-value', type)
  contents.textContent = message

  const stream = `
  <turbo-stream action="append" target="alerts-frame">
	  <template>
		  ${body.outerHTML}
	  </template>
  </turbo-stream>
  `

  Turbo.renderStreamMessage(stream)
}

export const alerts = {
  error: (message: string) => {
    alert('error', message)
  },
  success: (message: string) => {
    alert('success', message)
  },
  info: (message: string) => {
    alert('info', message)
  },
  warning: (message: string) => {
    alert('warning', message)
  },
}
